import React, { useState } from 'react'
import { func, shape, string, bool } from 'prop-types'
import LoadingDots from '../LoadingDots/LoadingDots'

import './ValidatedPromoInput.scss'

const ValidatedPromoInput = ({
  labels,
  handleBlur,
  submitValidation,
  clearValidation,
  code,
  valid,
  loading,
  disabled
}) => {
  const [inputValue, setInputValue] = useState(code || '')

  const validate = () => {
    if (valid === false) {
      setInputValue('')
      clearValidation()
    } else if (!disabled && !loading) {
      submitValidation(inputValue)
    }
  }
  const handleInputChange = evt => {
    if (valid !== null) {
      clearValidation()
    }
    setInputValue(evt.target.value)
  }

  const onBlur = () => {
    handleBlur(inputValue)
  }

  const inputClass = inputValue.length
    ? 'promo-input__field active'
    : 'promo-input__field'
  const labelClass = inputValue.length
    ? 'promo-input__floating-label'
    : 'promo-input__floating-label hidden'
  let buttonClass = 'btn btn-primary'
  let buttonContents = labels.validate

  if (loading) {
    buttonContents = (
      <div className="loading-container">
        <LoadingDots color="white" />
      </div>
    )
  } else if (valid === true) {
    buttonClass += ' btn-valid'
    buttonContents = '✓'
  } else if (valid === false) {
    buttonClass += ' btn-invalid'
    buttonContents = '✗'
  }

  return (
    <div className="promo-input">
      <div>
        <div className="promo-input__input-container">
          <label>
            <span className={labelClass}>
              {disabled ? labels.promoCode : labels.promoCodeCta}
            </span>
            <input
              className={inputClass}
              type="text"
              value={inputValue}
              onChange={handleInputChange}
              onBlur={onBlur}
              placeholder={labels.promoCodeCta}
              disabled={disabled}
            />
          </label>
          <button className={buttonClass} onClick={validate}>
            {buttonContents}
          </button>
        </div>
      </div>
      {valid !== null && (
        <span className="promo-input__msg-invalid">
          {valid ? labels.couponApplied : labels.promoCodeErrorMsg}
        </span>
      )}
    </div>
  )
}

ValidatedPromoInput.propTypes = {
  labels: shape().isRequired,
  handleBlur: func.isRequired,
  submitValidation: func.isRequired,
  clearValidation: func.isRequired,
  code: string.isRequired,
  valid: bool,
  loading: bool,
  disabled: bool
}

export default ValidatedPromoInput
